// extracted by mini-css-extract-plugin
module.exports = {"runnerName":"_f51b83d","marketIcon":"_b198458"};